export default "__VITE_ASSET__BUUuDlyG__"